module.exports = __webpack_public_path__ + "img/vu-scale-vertical.faa7fa99.svg";